import axios from "../axios";
import { BASE_URL } from "@src/utils";
import QueryString from "qs";

export type TAdvertiseType = 'WEDDING_HALL' | 'REMAINING_TIME' | 'NEARBY_RECOMMEND' 

export const getAdvertiseHallList = async (
  type:TAdvertiseType,
  regions?: string[]
) => {
  try {
    const regionsQuery = regions ? `&${QueryString.stringify({ regions })}` : '';
    const res = await axios.get(`${BASE_URL}/v3/book/partner/ad/hall?category=${type}${regionsQuery}`);
    return res.data;
  } catch (err) {
    console.log(err);
    return err;
  }
}